import { AppId } from '../../../ApplicationWrapper.types';
import { ProductName } from '../types';

const productEnvironmentExternalIdUrlSegmentRegex = /\/c-[^/]+/;
const productEnvironmentExternalIdUrlPrefix = '/c-';
// FIXME: remove along with usage once possible
const activeProductAppIdMap: { [key in ProductName]?: AppId } = {
  programmableMedia: AppId.MediaAPI,
  digitalAssetManagement: AppId.DigitalAssetManagement,
  accountSettings: AppId.Settings,
  video: AppId.Video,
};

// FIXME: consult whether we should add feature of checking if a product environment
// can be used in combination with a particular product
export const readInitialProductEnvironment = (localStorageClient: Storage, pageUrl: string, activeProductName: ProductName) => {
  const { pathname } = new URL(pageUrl);

  const parsedExternalId = productEnvironmentExternalIdUrlSegmentRegex.exec(pathname)?.[0].replace(productEnvironmentExternalIdUrlPrefix, '');

  if (parsedExternalId) {
    return { source: 'url' as const, externalId: parsedExternalId };
  }

  const activeProductAppId = activeProductAppIdMap[activeProductName];
  // FIXME: deprecated key also used by session-service, move to unicorn-owned one
  // once session service is absorbed
  const lastUsedProductEnvironment = localStorageClient.getItem(`cld-${activeProductAppId}-current-customer`);

  if (lastUsedProductEnvironment) {
    return { source: 'localStorage' as const, externalId: lastUsedProductEnvironment };
  }

  return { source: 'none' as const };
};
